function a(o, e = "", r) {
  let t = o;
  e = e.replace(/\[(\w+)\]/g, ".$1"), e = e.replace(/^\./, "");
  const i = e.split(".");
  let n = 0;
  for (let l = i.length; n < l - 1 && !(!t && !r); ++n) {
    const f = i[n];
    if (f in t)
      t = t[f];
    else {
      if (r)
        throw new Error("please transfer a valid prop path to form item!");
      break;
    }
  }
  return {
    obj: t,
    key: i[n],
    value: t ? t[i[n]] : null
  };
}
function g(o, e) {
  return o.filter((r) => !r.trigger || e === "" ? !0 : Array.isArray(r.trigger) ? r.trigger.indexOf(e) > -1 : r.trigger === e).map((r) => Object.assign({}, r));
}
function u() {
}
export {
  a as getPropByPath,
  g as getRuleForTrigger,
  u as noop
};
//# sourceMappingURL=utils.js.map
